import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import logUserAction from "utils/logging";
import { callUnsetApi } from "utils/api";
const SystemLogs = () => {
  const navigate = useNavigate();
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    const userData = sessionStorage.getItem("userData");
    if (!userData) {
      navigate("/");
    } else {
      sessionStorage.setItem("lastVisitedPage", "/logs/system_logs");
    }
    // Fetch data from the API
    fetch("https://api.bharatnet.sunshineiotronics.com/api/v2/logs/system") // Replace with your actual API endpoint
      .then((response) => response.json())
      .then((data) => setLogs(data))
      .catch((error) => console.error("Error fetching data:", error));
  }, [navigate]);
  const handleDownloadExcel = () => {
    // Prepare data for Excel
    const worksheetData = logs.map((log) => ({
      "Date and Time": log.datetime,
      Email: log.email,
      Description: log.desc,
    }));

    // Create a new worksheet
    const worksheet = XLSX.utils.json_to_sheet(worksheetData);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "System Logs");

    // Write the Excel file and trigger download
    XLSX.writeFile(workbook, "System_Logs.xlsx");
  };
  const handleDeleteLogs = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action will delete all logs permanently.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        // Perform delete request
        fetch("https://api.bharatnet.sunshineiotronics.com/api/v2/logs/system", {
          method: "DELETE",
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Failed to delete logs.");
            }
            Swal.fire("Deleted!", "The logs have been deleted.", "success");
            logUserAction("System Logs were deleted.");
            setLogs([]); // Clear logs from the state after successful deletion
          })
          .catch((error) => {
            console.error("Error deleting logs:", error);
            Swal.fire("Error", "Failed to delete logs.", "error");
          });
      }
    });
  };
  const siteId = sessionStorage.getItem("selectedSiteId");
  console.log(siteId);

  useEffect(() => {
    return () => {
      callUnsetApi(siteId);
    };
  }, [siteId]);
  const breadcrumbs = [
    <Link sx={{ color: "black" }}>Logs</Link>,
    <Typography key="3" sx={{ color: "text.primary" }}>
      System Logs
    </Typography>,
  ];
  return (
    <Box m="1.5rem 2.5rem">
      <div className="container-fluid page-body-wrapper">
        <br />
        <br />
        <div className="main-panel">
          <div className="content-wrapper">
            <Stack spacing={2}>
              <Breadcrumbs
                separator={<NavigateNextIcon fontSize="medium" />}
                aria-label="breadcrumb"
              >
                {breadcrumbs}
              </Breadcrumbs>
            </Stack>

            <div className="action-buttons" style={{ textAlign: "center" }}>
              <Button
                variant="outlined"
                color="secondary"
                sx={{ marginRight: "10px" }}
                onClick={handleDownloadExcel}
              >
                Download Excel
              </Button>
              <Button
                variant="outlined"
                color="error"
                sx={{ marginRight: "10px" }}
                onClick={handleDeleteLogs}
              >
                Delete Logs
              </Button>
            </div>
            <TableContainer
              component={Paper}
              elevation={3}
              sx={{
                marginTop: "30px",
                borderRadius: "12px",
                overflow: "hidden",
              }}
            >
              <Table>
                <TableHead sx={{ backgroundColor: "rgb(250,223,186)" }}>
                  <TableRow>
                    <TableCell sx={{ color: "#997d3d", fontWeight: "bold" }}>
                      Date and Time
                    </TableCell>
                    <TableCell sx={{ color: "#997d3d", fontWeight: "bold" }}>
                      Email
                    </TableCell>
                    <TableCell sx={{ color: "#997d3d", fontWeight: "bold" }}>
                      Description
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {logs.map((log) => (
                    <TableRow key={log._id}>
                      <TableCell>{log.datetime}</TableCell>
                      <TableCell>{log.email}</TableCell>
                      <TableCell>{log.desc}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default SystemLogs;
